import React, {useEffect, useState} from 'react'

import Team from '../../models/Team'

import BiddingContractSubstep from './BiddingContractSubstep'
import Project from "../../models/Project";
import AnimatedNumber from "animated-number-react";
import {CheckBox} from "../../components/form/CheckboxInput";

const ProjectExpenseBudgetInput = ({project, editable, isEditing, onEdit, onUpdate, disabled}) => {

    const [expenseBudget, setExpenseBudget] = useState(Number(project.expense_budget).toFixed(0));

    useEffect(() => {
        const resetApproved = () => {
            setExpenseBudget(Number(project.expense_budget).toFixed(0))
        };
        resetApproved();
    }, [project.expense_budget]);


    return (
        <td className="sow-table-cell expense-input-field" colSpan={3}>
            <div className="input-container">
                {(editable && isEditing) ? (
                    <div className="form-group">
                        <div className={"input-group " + (disabled && 'disabled')}>

                            <span className={"input-group-prepend " + (disabled && 'disabled')}>
                                $
                            </span>
                            <input type="number" name="expense_budget"
                                   onChange={(e) => setExpenseBudget(e.target.valueAsNumber)}
                                   disabled={disabled}
                                   value={expenseBudget}
                                   min={0}/>

                        </div>
                    </div>
                ) : `$ ${expenseBudget}`}

                {(isEditing || editable) && (
                    <button
                        onClick={() => {
                            if (!isEditing) {
                                return onEdit();
                            }

                            if (expenseBudget < 0) {
                                return TB.toast("Expense budget must be $0 or greater")
                            }
                            return onUpdate(expenseBudget)
                        }}
                        className="btn-link btn-link-primary mx-2">
                        {!isEditing ? "Edit" : "Apply"}
                    </button>
                )}
            </div>
            <p>
                The default has been set to 10% of fees.
            </p>
        </td>
    )

}
export default class BiddingContractFeesSubstep extends BiddingContractSubstep {
    // static SubstepName = 'Approve Project Budget';
    static SubstepName = 'start_project.contract_fees.title';

    static TranslationKey = 'start_project.contract_fees';

    static SubstepSlug = 'project-fees';
    static path = '/project-fees';

    static StepTitle = 'Confirm Max Project Hours, Fees, and Expenses';

    static getStepName(project) {
        return (project.acceptsStandardSOW() && project.isBYO()) ? 'Approve Project Fees & Expenses' : this.SubstepName;
    }

    constructor(props) {
        super(props);

        this.formRef = React.createRef();

        let editingProject = {
            ...props.project,
        }

        if (props.project.isBYO() && props.project.acceptsStandardSOW()) {
            if (TB.isNaN(parseFloat(editingProject.expense_budget))) {

                editingProject.expense_budget = parseInt(editingProject.platform_cost || '0') * 0.10;
                editingProject.accepts_max_fees = true;
            }
        }
        editingProject = Project.make(editingProject)

        this.state = {
            ...this.state,
            editingProject,
        }
    }


    renderOverviewDetails() {
        let {project} = this.props;

        return (
            <div className="flex flex-row items-center flex-wrap mt-3 mb-5">
                <div className="md:basis-3/12 sm:basis-6/12 xs:basis-full">
                    <p className="sow-overview-info">
                        {this.trans('contract_type_label')}<br/>
                        <span className="sow-overview-value">{project.contractTypeName()}</span>
                    </p>
                </div>
                <div className="md:basis-3/12 sm:basis-6/12 xs:basis-full">
                    <p className="sow-overview-info">
                        {this.trans('invoice_terms_label')}<br/>
                        <span className="sow-overview-value">{project.invoiceTerms()}</span>
                    </p>
                </div>
                <div className="md:basis-3/12 sm:basis-6/12 xs:basis-full">
                    <p className="sow-overview-info">
                        {this.trans('budget_label')}<br/>
                        <span className="sow-overview-value">{project.budgetRange()}</span>
                    </p>
                </div>
                <div className="md:basis-3/12 sm:basis-6/12 xs:basis-full">
                    <p className="sow-overview-info">
                        {this.trans('timing_label')}<br/>
                        <span className="sow-overview-value">{project.timeRangeName() || '---'}</span>
                    </p>
                </div>
                {project.isFixedFee() && (
                    <div className="md:basis-3/12 sm:basis-6/12 xs:basis-full">
                        <p className="sow-overview-info">
                            Grand Total<br/>
                            <span className="sow-overview-value">
                                {project.totalCostWithServiceFee()}
                            </span>
                        </p>
                    </div>
                )}
            </div>
        );
    }

    renderDisciplineCosts(project) {
        let multiplier = project.percent_markup + 1;
        let disciplines = project.requiredDisciplines();
        let disciplineCosts = [];
        if (TB.isObject(project.team)) {
            disciplineCosts = Team.make({...project.team}).disciplineBulkEstimatesFor(
                project
            );

            disciplineCosts = TB.keyBy(disciplineCosts, 'id');
        }

        let lineItems = [];
        for (let discipline of disciplines) {
            let breakdown = disciplineCosts[discipline.id];
            if (!breakdown) {
                continue;
            }

            lineItems.push({
                name: breakdown.name,
                owned_hours: breakdown.total_hours,
                hourly_rate: breakdown.hourly_rate * multiplier,
                estimated_cost: breakdown.estimate * multiplier,
            });
        }

        // if (TB.isObject(project.engagement_lead)) {
        //     lineItems.push({
        //         name: project.engagement_lead.discipline.name,
        //         owned_hours: project.engagement_lead.total_hours,
        //         hourly_rate: project.engagement_lead.hourly_rate * multiplier,
        //         estimated_cost: project.engagement_lead.estimated_cost * multiplier,
        //     });
        // }

        // let totalCost = TB.sumBy(lineItems, 'estimated_cost');
        // console.log('Total Cost: ' + totalCost);

        return (
            <tbody>
            {lineItems.map((discipline, i) => (
                <tr key={`projectDisciplineFees${i}`}>
                    <td className="sow-table-cell" style={{paddingLeft: 15}}>{discipline.name}</td>
                    <td className="sow-table-cell">{TB.formatNumber(discipline.owned_hours, 1)} Hours</td>
                    <td className="sow-table-cell">{TB.formatCurrency(discipline.hourly_rate, false)}</td>
                    <td className="sow-table-cell" style={{textAlign: 'right', paddingRight: 15}}>
                        {TB.formatCurrency(discipline.estimated_cost, false)}
                    </td>
                </tr>
            ))}
            </tbody>
        );
    }

    applyAnimate(number, currency = true) {
        let format = value => TB.formatCurrency(value, false);
        if (!currency) format = value => Number(value).toFixed(0)
        return (
            <AnimatedNumber
                value={number}
                formatValue={format}
                duration={1000}
            />
        )
    }

    renderApproveMaxFeesTable() {

        let {editingProject, isLoading} = this.state;

        let {canEditSOWForProject, forReview, isLocked, isDisabled} = this.props;

        const editable = canEditSOWForProject && !forReview && !isLocked;
        const disabled = isDisabled || isLoading;

        let platformCostWithAcceptedFees = editingProject.platform_cost;
        if (editingProject.accepts_max_fees) {
            platformCostWithAcceptedFees = editingProject.platform_cost + (parseFloat(editingProject.platform_cost || '0') * 0.10)
        }

        return (
            <div className="table-responsive">


                <table className="table"
                       style={{textAlign: 'left', background: '#F5F6F8', minWidth: '600px'}}>

                    <tbody>

                    <tr>
                        <td className="sow-table-cell sow-table-title" colSpan={2}>
                            <p><b>Change Order Buffer</b></p>
                        </td>
                    </tr>
                    {!forReview && !isLocked && (
                        <tr>
                            <td className="sow-table-cell sow-table-instructions" colSpan={2}>
                                <p>
                                    A change order will be required for this project if the actual project fees exceed the estimated fees above, plus any change order buffer. By default, we recommend a 10% buffer (but acceptance is optional), meaning the project would have to exceed the fees above by 10% before a change order is required.
                                </p>
                            </td>
                        </tr>
                    )}

                    <tr>
                        <td className="sow-table-cell sow-table-input" style={{width: "65%"}}>
                            <div className="cost-input-instruction">
                                <i className="fas fa-arrow-right fa-2x mr-2"/>
                                <CheckBox
                                    checkboxClass={TB.mapClass("justify-center", {
                                        'no-click':disabled || !editable
                                    })}
                                    disabled={disabled || !editable}
                                    name="accepts_max_fees"
                                    label={<span>Accept +10% <b>change order buffer</b></span>}
                                    required={false}
                                    value={!!editingProject.accepts_max_fees}
                                    setValue={() => {
                                        const value = !this.state.editingProject.accepts_max_fees;

                                        let updatedProject = TB.set({...this.state.editingProject}, 'accepts_max_fees', value ? 1 : 0);

                                        updatedProject = Project.make(updatedProject);

                                        return this.setState({editingProject: updatedProject})
                                    }}/>

                            </div>

                        </td>


                        <td className="sow-table-cell" style={{width: '35%'}}>
                            <span className="sow-table-total">
                            <span>A change will be issued if the project fees exceed</span>
                            <span>
                                <b>
                                    {this.applyAnimate(platformCostWithAcceptedFees)}
                                </b>
                            </span>
                            </span>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        )
    }

    renderExpenseBudgetTable() {

        let {editingProject, isLoading, activePositionId} = this.state;

        let {canEditSOWForProject, forReview, isLocked, isDisabled} = this.props;

        const editable = canEditSOWForProject && !forReview && !isLocked;
        const disabled = isDisabled || isLoading;

        return (
            <div className="table-responsive">

                <table className="table"
                       style={{textAlign: 'left', background: '#F5F6F8', minWidth: '600px'}}>

                    <tbody>
                    <tr>
                        <td className="sow-table-cell sow-table-title" colSpan={3}>
                            <p><b>Out of Pocket Expenses</b></p>
                        </td>
                    </tr>
                    {!forReview && !isLocked && (
                        <tr>
                            <td className="sow-table-cell sow-table-instructions" colSpan={3}>
                                <p>By default, we have set the budget for out-of-pocket expenses to 10% of estimated fees above. You can edit this budget below.</p>
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td className="sow-table-cell sow-table-input" style={{width: '25%'}}>
                            Project Out Of Pocket Expense Budget
                        </td>

                        <ProjectExpenseBudgetInput
                            project={editingProject}
                            disabled={disabled}
                            isEditing={activePositionId === 'expense_budget'}
                            onEdit={() => this.setState({activePositionId: 'expense_budget'})}
                            editable={editable && (!activePositionId || activePositionId === 'expense_budget')}
                            onUpdate={async (expense_budget) => {
                                if (isLoading) {
                                    return false;
                                }
                                await this.promisedState({
                                    isLoading: true,
                                    activePositionId: undefined
                                });

                                let props = {...editingProject};
                                props = TB.set(props, `expense_budget`, expense_budget);

                                await this.promisedState({editingProject: Project.make({...props}), isLoading: false});

                                return true;
                            }}/>

                        <td className="sow-table-cell text-right" style={{width: '25%'}}>
                            <span className="sow-table-total">
                                <span>Total Approved Expenses</span>
                                <span>
                                    <b>
                                        {this.applyAnimate(editingProject.expense_budget)}
                                    </b>
                                </span>
                            </span>

                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        )
    }

    renderPositionCosts(positions, includeMaxHours) {
        return (
            <tbody>
            {positions.map((position, i) => {
                let totalHours = position.estimated_total_periods;
                let hourlyRate = position.platform_rate;

                let bulkCost = position.platform_cost;
                let totalCost = bulkCost ? bulkCost : '---';

                totalCost = this.applyAnimate(totalCost)

                return (
                    <tr key={`project-position-fees${i}`}>
                        <td className="sow-table-cell" style={{paddingLeft: 15}}>
                            {position.title}
                        </td>
                        <td className="sow-table-cell">
                            {totalHours} Hours
                        </td>
                        <td className="sow-table-cell">
                            {hourlyRate}
                        </td>
                        <td className="sow-table-cell" style={{textAlign: 'right', paddingRight: 15}}>
                            {totalCost}
                        </td>
                    </tr>
                );
            })}
            </tbody>
        );
    }


    renderCostsBreakdownTable() {
        let {project, canEditSOWForProject, forReview, isLocked, isDisabled} = this.props;
        if (!project) {
            return <div/>
        }
        if (!project || (project.isService() && project.isFixedFee())) {
            return <div/>;
        }

        let {acceptApprovedHours, isLoading} = this.state;

        const disabled = isDisabled || isLoading;

        let positions = this.state.editingProject.positions;

        let totalResources = project.totalResources();

        const includeMaxFees = project.isBYO() && project.acceptsStandardSOW();

        let platformCost = this.state.editingProject.platform_cost;

        // let totalHours = this.applyAnimate(TB.sumBy(positions, 'actual_total_periods'), false);

        if (includeMaxFees) {
            platformCost = this.applyAnimate(platformCost)
        } else {
            platformCost = TB.formatCurrency(platformCost, false);
        }

        return (
            <div className="table-responsive">


                <table className="table"
                       style={{textAlign: 'left', background: '#F5F6F8', minWidth: '600px'}}>
                    <thead>
                    <tr>
                        <th className="sow-table-header" style={{paddingLeft: 15}}>Resources</th>
                        <th className="sow-table-header">Estimated Hours*</th>
                        <th className="sow-table-header">Hourly Rate**</th>
                        <th className="sow-table-header" style={{textAlign: 'right', paddingRight: 15}}>
                            Total Approved Fees
                        </th>
                    </tr>
                    </thead>

                    {project.isBYO() && this.renderPositionCosts(positions, includeMaxFees)}

                    {project.isService() && this.renderDisciplineCosts(project)}

                    <tfoot>
                    <tr>
                        <td className="sow-table-footer" style={{paddingLeft: 15}}>
                            {totalResources} Resources
                        </td>
                        <td className="sow-table-footer">
                            {project.hourlyTotal()} Hours
                        </td>

                        <td className="sow-table-footer"/>

                        <td className="sow-table-footer" style={{textAlign: 'right', paddingRight: 15}}>
                            {platformCost}
                        </td>
                    </tr>
                    </tfoot>

                </table>

            </div>
        );
    }

    renderStepContent() {
        let {project, canEditSOWForProject, forReview, isLocked, isDisabled} = this.props;
        if (!project) {
            return <div/>
        }

        return (
            <div className="sow-fees-step">
                {this.renderOverviewDetails()}

                {this.renderCostsBreakdownTable(project)}


                {project.acceptsStandardSOW() && project.isBYO() && this.renderApproveMaxFeesTable()}
                {project.acceptsStandardSOW() && project.isBYO() && this.renderExpenseBudgetTable()}

                {project.isTimeMaterials() && (
                    <div className="row sow-hourly-rate-terms">
                        <div className="md:w-9/12 sm:w-10/12 lg:w-11/12">
                            <h3>
                                <i>
                                    <b>*</b> Company will pay Wripple on a “time and materials” basis for (i) the
                                    actual, reasonably incurred time at the hourly rate(s) set forth above and (ii)
                                    authorized expenses above necessary to complete the Services, <b>provided that such
                                    payments to be made under this SOW shall never exceed max hours above by more than
                                    10% in the aggregate.</b> Fees incurred within this range will not require a change
                                    order.
                                </i>
                            </h3>
                            <br/>
                            <h3>
                                <i>
                                    <b>**</b>{` Hourly rates above include a ${laravel.platform_name} platform fee that covers:
                                     (1) unlimited company access to ${laravel.platform_name}’s Agency Services Platform,
                                     (2) support from a dedicated ${laravel.platform_name} Client Lead,
                                     (3) brand and talent onboarding,
                                     (4) our talent quality guarantee and
                                     (5) talent vetting and administration of talent contracts, payments and operations.`}
                                </i>
                            </h3>
                        </div>
                    </div>
                )}

                {project.acceptsStandardSOW() && project.isBYO() && !forReview && (
                    <div className="mt-5 items-start flex">
                        <button
                            type="button"
                            onClick={async () => {
                                if (!canEditSOWForProject) {
                                    return TB.showPermissionError();
                                }

                                await this.promisedState({isLoading: true})

                                let props = TB.pick(this.state.editingProject, ['accepts_max_fees', 'expense_budget'])
                                let response = await this.props.makeRequest(
                                    () => this.props.project.update(props),
                                    Project.SyncRequest
                                );
                                if (!response) {
                                    await this.promisedState({isLoading: false})
                                    return TB.showServerErrorToast();
                                }

                                await this.promisedState({isLoading: false})

                                return this.props.approveStep();
                            }}
                            className={TB.mapClass('btn btn-primary approve-btn', {'disabled-edit-link': !canEditSOWForProject})}
                            disabled={this.props.isDisabled || this.props.isLocked || this.state.activePositionId}
                        >
                            Approve & Continue
                            {!canEditSOWForProject && (<i className="fa fa-lock ml-1"/>)}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}